<div class="pattern-detail-container">
  @if (loading) {
  <div class="loading">
    Loading pattern details...
  </div>
  }

  @if (!loading && pattern) {
  <div>
    <div class="scheduler-container">
      <app-pattern-entry-scheduler [pattern]="patternObj" (patternChanged)="loadPattern()">
      </app-pattern-entry-scheduler>
    </div>
  </div>
  }
</div>